import { Icon } from '@progress/kendo-react-common';
import {
  InputPrefix,
  InputSuffix,
  TextBox,
  TextBoxChangeEvent,
  TextBoxProps,
} from '@progress/kendo-react-inputs';
import { FC, MouseEvent, useCallback } from 'react';

interface SearchBoxProps extends Omit<TextBoxProps, 'prefix' | 'suffix' | 'onChange'> {
  width: string;
  onChange: (value: string) => void;
}

const SearchBox: FC<SearchBoxProps> = ({ value, onChange, width, ...other }) => {
  const handleChange = useCallback(
    (event: TextBoxChangeEvent) => {
      if ((event.target.value as string)?.startsWith(' ')) {
        event.nativeEvent.preventDefault();
      } else {
        onChange(event.value as string);
      }
    },
    [onChange]
  );

  const handleClear = useCallback(
    (event: MouseEvent<HTMLSpanElement>) => {
      onChange('');
    },
    [onChange]
  );

  return (
    <TextBox
      value={value}
      onChange={handleChange}
      {...other}
      style={{ width }}
      prefix={() => (
        <>
          <InputPrefix>
            <Icon name="search" style={{ color: '#AAAAAA' }} />
          </InputPrefix>
        </>
      )}
      suffix={() => (
        <>
          <InputSuffix onClick={handleClear}>
            {!!value && <Icon name="close" style={{ color: '#AAAAAA' }} />}
          </InputSuffix>
        </>
      )}
    />
  );
};

export default SearchBox;
